export default __webpack_public_path__ + "static/media/vo-100-percent-finished.8a6947ee.aac";